import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ErrorService } from '@platform/OLD_error/error.service';
import { paths } from '@platform/paths';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

/**
 * This guard should only be used on error route
 */

@Injectable()
export class ErrorGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly errorService: ErrorService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.errorService.errorsShown$.pipe(
      take(1),
      map((errorsExist: boolean) => {
        return true;
        if (errorsExist) {
          return true;
        }
        this.router.navigate([paths.PLATFORM, paths.platform.DASHBOARD]);
        return false;
      }),
    );
  }
}
